import { useTenant } from "@/providers/session";
import type { SortingState } from "@tanstack/react-table";
import { useEffect, useState } from "react";
type Sorting = {
  id: string;
  desc: boolean;
};

const useTableSorting = (
  tableName: string,
  initialSorting: SortingState = [{ id: "createdAt", desc: true }],
) => {
  const [sorting, setSorting] = useState<SortingState>(initialSorting);
  const { tenantId } = useTenant();

  useEffect(() => {
    if (!tenantId) return;
    const storedSorting = sessionStorage.getItem(
      `${tenantId}_${tableName}_sorting`,
    );
    if (storedSorting != null && storedSorting !== "undefined") {
      setSorting(JSON.parse(storedSorting));
    } else {
      setSorting(initialSorting);
    }
  }, [tenantId, tableName]);

  const updateSorting = (newSorting: Sorting[]) => {
    if (!tenantId) return;

    sessionStorage.setItem(
      `${tenantId}_${tableName}_sorting`,
      JSON.stringify(newSorting ?? []),
    );
  };
  const onSortingChange = (sortingState: any) => {
    setSorting((old) => {
      const newState = sortingState(old);
      updateSorting(newState);
      return newState;
    });
  };

  return { sorting, onSortingChange };
};

export default useTableSorting;
